import { getUserInfo } from '@sorted/pkce-oauth';

const getMockProductClaims = () => {
	const activeProducts = window.localStorage.getItem(
		'sorted-ui-host.productClaims'
	);
	// defaulting this to permit access to both products as it's the best option for now
	return activeProducts ? activeProducts.split(',') : ['PRO']; // ['REACT', 'PRO'];
};

const buildUserDetails = async settings => {
	const user = await getUserInfo(settings);
	user.productClaims = getMockProductClaims();
	return user;
};

export default buildUserDetails;
